import type { Types as OData } from 'shared/odata'

import { apiRTK, Tag } from 'api/api-rtk'

import type * as Api from './types'

export const api = apiRTK.injectEndpoints({
	endpoints: create => ({
		scheduledMessages: create.query<
			OData.PageResponse<Api.ScheduledMessage>,
			Partial<OData.Page>
		>({
			providesTags: [Tag.ScheduledMessages],
			query: params => ({
				method: 'GET',
				params,
				url: 'scheduled-messages/page'
			})
		}),

		scheduleMessage: create.mutation<Api.ScheduledMessage, Api.NewMessage>({
			invalidatesTags: [Tag.ScheduledMessages],
			query: data => ({
				data,
				method: 'POST',
				url: 'scheduled-messages'
			})
		}),

		sendScheduledMessage: create.mutation<void, string>({
			invalidatesTags: [Tag.ScheduledMessages],
			query: id => ({
				method: 'POST',
				url: `scheduled-messages/${id}/send`
			})
		}),

		unScheduleMessage: create.mutation<void, string>({
			invalidatesTags: [Tag.ScheduledMessages],
			query: id => ({
				method: 'DELETE',
				url: `scheduled-messages/${id}`
			})
		}),

		updateScheduledMessage: create.mutation<
			Api.ScheduledMessage,
			Api.Update & { id: string }
		>({
			invalidatesTags: [Tag.ScheduledMessages],
			query: ({ id, ...data }) => ({
				data,
				method: 'PUT',
				url: `scheduled-messages/${id}`
			})
		})
	}),
	overrideExisting: true
})
